import { useContext } from "react";
import BNAlert, { UmbracoLink, UmbracoNotification } from "@bn-monorepo/js-packages/src/Components/BNAlert/BNAlert";
import { SettingsContext } from "../../../../../settingsContext";
import { BNBox } from "@bn-monorepo/js-packages";
import { Stack } from "@mui/material";

interface Props {
  notificationList: UmbracoNotification[];
}

const SectionPageNotification: React.FC<Props> = ({ notificationList }) => {
  const { resolveUrl } = useContext(SettingsContext);

  return (
    <BNBox sx={{ maxWidth: "123.2rem", m: "0 auto", p: 2 }}>
      <Stack spacing={1}>
        {notificationList.map((notification) => (
          <BNAlert
            resolveUrl={resolveUrl}
            isSpa={(link: UmbracoLink) => link.type === "Content"}
            id={notification.key}
            {...notification}
          />
        ))}
      </Stack>
    </BNBox>
  );
};

export default SectionPageNotification;
